import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { get } from "../../service/api";

const VatDistrictSelect = ({ value, onChange, extra = null, multi = null }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    get(`/reference/vatDistrict`).then((response) => {
      console.log(response);
      if (response) {
        var data = response.data.data.map((e) => {
          return {
            label: `${e.branchName} - ${e.subBranchName}`,
            value: e.branchCode + e.subBranchCode,
          };
        });
        if (extra) data.unshift(extra);
        setData(data);
        if (!value) {
          onChange(data[0].value);
        } else {
          if (data.findIndex((e) => e.value === value) > 0) onChange(value);
          else onChange(data[0].value);
        }
      }
    });
  }, []);
  const onInputChange = (e, label, extra) => {
    onChange(e);
  };

  return (
    <Select
      mode={multi}
      style={{
        width: "100%",
      }}
      showSearch
      filterOption={(input, option) => {
        return String(option.label).trim().toLowerCase().includes(input);
      }}
      value={value}
      dropdownStyle={{
        maxHeight: 400,
        overflow: "auto",
      }}
      options={data}
      placeholder="сонгоно уу"
      treeDefaultExpandAll
      onChange={onInputChange}
    />
  );
};
export default VatDistrictSelect;
